import { render } from "./Outer.vue?vue&type=template&id=48a70eca&scoped=true&lang=pug"
import script from "./Outer.vue?vue&type=script&lang=js"
export * from "./Outer.vue?vue&type=script&lang=js"

import "./Outer.vue?vue&type=style&index=0&id=48a70eca&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a70eca"]])

export default __exports__